module.exports = __webpack_public_path__ + "img/head_img.fe436ea5.png";